import { render, staticRenderFns } from "./PendingOrder.vue?vue&type=template&id=5b999d80&scoped=true"
import script from "./PendingOrder.vue?vue&type=script&lang=js"
export * from "./PendingOrder.vue?vue&type=script&lang=js"
import style0 from "./PendingOrder.vue?vue&type=style&index=0&id=5b999d80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b999d80",
  null
  
)

export default component.exports